var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service-selection-section"},[_c('div',{staticClass:"service-cards-container"},_vm._l((_vm.services),function(service,index){return _c('ServiceCard',{key:index,attrs:{"service":service,"selected":_vm.selectedServiceId === service.id,"show-upgrade":_vm.shouldShowUpgrade(service)},on:{"select":_vm.handleSelect}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }